export default function NotFound() {
  return (
    <div className="not-found">
      <h1>404 - Страница не найдена</h1>
      <p>Извините, запрашиваемая страница не существует.</p>
    </div>
  );
}